export const APP_CREATE = 'APP_CREATE';
export const APP_CREATE_SUCCESS = 'APP_CREATE_SUCCESS';
export const APP_CREATE_ERROR = 'APP_CREATE_ERROR';
